import React from 'react';
import { Button, Stack } from '@mui/material';
import ReplyIcon from '@mui/icons-material/Reply';

import { EmptyCandidateFilters } from '@hooks';
import { toggle } from '@utils';
import { ICandidatesControls } from '../controls';
import { CandidateSearch } from './CandidateSearch';
import { CandidateFilters } from './CandidateFilters';
import { ColumnMenu } from './ColumnMenu';
import { GroupByMenu } from './GroupByMenu';
import { PositionFilterChips } from './PositionFilterChips';
import { ShowRejectedToggle } from './ShowRejectedToggle';

export const DesktopCandidatesToolbar: React.FC<ICandidatesControls> = ({
  data,
  filterOptions,
  view,
  activeFilterCount,
  isDefault,
  inactiveCount,
  onChange,
  onReset,
}) => (
  <Stack gap={1.5} px={2}>
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{ '& > *': { maxWidth: '100%' } }}
    >
      <CandidateSearch
        data={data}
        value={view.query}
        onChange={(query) => onChange({ query })}
      />

      <CandidateFilters
        {...filterOptions}
        selectedRegions={view.regions}
        selectedSeniorities={view.seniorities}
        selectedStatuses={view.statuses}
        activeCount={activeFilterCount}
        onChange={onChange}
        onClear={() => onChange(EmptyCandidateFilters)}
      />

      <Stack
        direction="row"
        gap={1}
        alignItems="center"
        flexWrap="wrap"
        sx={{ ml: 'auto' }}
      >
        <ShowRejectedToggle
          checked={view.showRejected}
          count={inactiveCount}
          onChange={(showRejected) => onChange({ showRejected })}
        />

        <GroupByMenu
          value={view.groupBy}
          onChange={(groupBy) => onChange({ groupBy })}
        />

        <ColumnMenu
          selected={view.columns}
          onChange={(columns) => onChange({ columns })}
        />

        <Button
          variant="text"
          size="small"
          disabled={isDefault}
          startIcon={<ReplyIcon />}
          onClick={onReset}
          sx={{
            minHeight: '2.5rem',
            color: 'text.secondary',
            textTransform: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          Reset
        </Button>
      </Stack>
    </Stack>

    <PositionFilterChips
      positions={data}
      selectedIds={view.positionIds}
      onToggle={(id) => onChange({ positionIds: toggle(view.positionIds, id) })}
    />
  </Stack>
);
